import React, { useEffect, useState, useContext } from "react";
import iosService from "../../../../services/api/sortd-apps/ios-service";
import formValidations from "../../../../variables/form-validations";
import '../../settings.css';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import ProjectContext from "../../../../ProjectContext";

const AddUser = (props)=> {

  const projectId = props.projectId;
  const projectDetails = useContext(ProjectContext);

  const [formdetails, setFormDetails] = useState({projectId:projectId,email:'', firstName:'', lastName : ''});
  const [showLoader, setShowLoader]   = useState(false);
  const [showSaveButton, setShowSaveButton]   = useState(true);
  const [alert, setAlert]   = useState({show:false,message:'',type:''});

  const [fieldStates ,setFieldStates] = useState([]);

  const handleChange = (event) => {
    setFormDetails({
      ...formdetails,
      [event.target.name]: ( event.target.value ).trim(),
    });
    fieldStates['error_'+event.target.name] = "has-success";
    fieldStates['error_message_'+event.target.name] = "";
    setFieldStates({
        ...fieldStates,
        fieldStates
      });
  }

  const handleBlur = (event) => {
    
  }

  const validateFields = () => {
    let validations = true;
    if(formdetails.email===''){
      fieldStates["error_email"] = "has-danger";
      fieldStates["error_message_email"] = "email is required";
      validations = false;
    }else{
        if(!formValidations.verifyEmail(formdetails.email)){
          fieldStates["error_email"] = "has-danger";
          fieldStates["error_message_email"] = "Please enter a valid email.";
          validations = false;
      }
    }
    if(formdetails.firstName.trim()===''){
      fieldStates["error_firstName"] = "has-danger";
      fieldStates["error_message_firstName"] = "First Name is required";
      validations = false;
    }
    if(formdetails.lastName.trim()===''){
      fieldStates["error_lastName"] = "has-danger";
      fieldStates["error_message_lastName"] = "Last Name is required";
      validations = false;
    }
    setFieldStates({
        ...fieldStates,
        fieldStates
    });
    return validations;
}
  
  const handleSubmit = function(e){  validateForm();e.preventDefault() }
 
  const validateForm = async () => {
    let isValid = validateFields();
    console.log("InvitedUser",formdetails);
    if(isValid){
      setShowLoader(true);
      setShowSaveButton(false);
      let addUser = await iosService.addUserToAppleAccount(formdetails);
      if(projectDetails.isContractExpired){
        setShowLoader(false);
        setShowSaveButton(true);
        projectDetails.setContractExpiredAlert(projectDetails);
      }
      else if(addUser.status){
        if(addUser.data && addUser.data.attributes){
          setTimeout(()=>{
            setShowLoader(false)
            setAlert({show:true,type:'success',message:'Invitation was sent Successfully'});
          },1000);
          
          setTimeout(()=>{
            setAlert({show:false,type:'',message:''});
          },3000);
  
          setTimeout(()=>{
            props.onCancel()
            // props.setShowAddUser(false);
          },3000);
        }
        else if(!addUser.data.success && addUser.data.code){
          setTimeout(()=>{
            setShowLoader(false)
            setShowSaveButton(true)
            setAlert({show:true,type:'danger',message:'Invitation already sent or email is already associated .'});
          },1000);
  
          setTimeout(()=>{
            setAlert({show:false,type:'',message:''});
          },8000);
        }
        
      }else{
        if(addUser.error)
        {
          setTimeout(()=>{
          setShowLoader(false)
          setShowSaveButton(true)
          setAlert({show:true,type:'danger',message:addUser.error.message});
        },1000); 
      }else
      {
        setTimeout(()=>{
          setShowLoader(false)
          setShowSaveButton(true)
          setAlert({show:true,type:'danger',message:'Invitation could not be sent, Please try again.'});
        },1000);
      }
        setTimeout(()=>{
          setAlert({show:false,type:'',message:''});
        },8000);
      }
    }
  }
  
    return (
      <div className="content mt-30">
        <Container>
          <Row>
          <Col className="ml-auto mr-auto"  md="12">
              {/* <Card className="card-signup text-center dp-box">
                <CardHeader>
                  
                </CardHeader>
                <CardBody> */}
                  <Form className="form-horizontol" action="" id="inviteUser" method="POST" onSubmit={handleSubmit}>
                  <Row>
                  <div className="consFom">
                      <Label className="lblNme">First Name</Label>
                      <div className="inptFom1 mb-0">
                      <Input
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="First Name"
                        name = "firstName"
                        id="firstName"
                        onChange={handleChange }
                      />
                      <InputGroup className={fieldStates["error_firstName"]}>

                      {fieldStates["error_firstName"] === "has-danger" ? (
                            <label className="error">
                              {fieldStates["error_message_firstName"]}
                            </label>
                          ) : null} 
                    </InputGroup>
                      </div>
                  </div>
                  </Row>
                  <Row>

                  <div className="consFom">
                      <Label className="lblNme">Last Name</Label>
                      <div className="inptFom1 mb-0">
                      <Input
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Last Name"
                        name = "lastName"
                        id="lastName"
                        onChange={handleChange }
                      />
                      <InputGroup className={fieldStates["error_lastName"]}>

                      {fieldStates["error_lastName"] === "has-danger" ? (
                            <label className="error">
                              {fieldStates["error_message_lastName"]}
                            </label>
                          ) : null}  
                    </InputGroup>
                      </div>
                  </div>
                  </Row>
                  <Row>
                    <div className="consFom">
                        <Label className="lblNme">Email</Label>
                        <div className="inptFom1 mb-0">
                        <InputGroup className={fieldStates["error_email"]}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText  className="emailIcon"  style={{height:'auto'}}>
                            <i className="nc-icon nc-email-85" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input id="email" name="email" placeholder="Email..." type="text"  onChange={handleChange} onBlur={handleBlur}/>
                        {fieldStates["error_email"] === "has-danger" ? (
                              <label className="error">
                                {fieldStates["error_message_email"]}
                              </label>
                            ) : null}   
                      </InputGroup>
                        </div>
                    </div>
                  </Row>

                  <Row>

                  <div className="dflLft">
                    {showSaveButton?
                    <>
                    <Button
                      className="btn-smb btnBlue"
                      type="button"
                      onClick={validateForm}
                    >
                      Invite User
                    </Button>
                  <Button 
                    className="btn-smb btnBlk"
                    type="button"
                    onClick={(event)=>  props.onCancel() }
                  >
                    cancel
                  </Button></>
                    :''}
                  </div>
                  {/* {showSaveButton?<Button
                    className="btn-round"
                    color="danger"
                    type="button"
                    onClick={(event)=>  props.setShowAddUser(false) }
                  >
                    Back
                  </Button>:''} */}
                  <div className="dflLft">
                  {alert.show?<Alert color={alert.type}>
                    {alert.message}
                  </Alert>:''}

                  {showLoader?<Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>:''}
                  </div>
                  </Row>
                  </Form>
                {/* </CardBody>
                <CardFooter>
                </CardFooter>
              </Card> */}
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("../../../../assets/img/bg/jan-sendereks.jpg")})`,
          }}
        />
      </div>
    );
  
}

export default AddUser;
